import React from 'react';
import { Route } from 'react-router-dom';
import ManageClasses from '@/pages/routine/ManageClasses';
import ClassSchedule from '@/pages/routine/ClassSchedule';
import ClassReport from '@/pages/routine/ClassReport';
import PrintRoutine from '@/pages/routine/PrintRoutine';
import TeacherWiseRoutine from '@/pages/routine/TeacherWiseRoutine';
import ClassAttendance from '@/pages/routine/ClassAttendance';
import ManageExam from '@/pages/routine/ManageExam';
import ExamReport from '@/pages/routine/ExamReport';
import RoutineSetting from '@/pages/routine/RoutineSetting';

export const routineRoutes = (
  <React.Fragment>
    <Route path="routine/manage-classes" element={<ManageClasses />} />
    <Route path="routine/class-schedule" element={<ClassSchedule />} />
    <Route path="routine/class-report" element={<ClassReport />} />
    <Route path="routine/print" element={<PrintRoutine />} />
    <Route path="routine/teacher-wise" element={<TeacherWiseRoutine />} />
    <Route path="routine/class-attendance" element={<ClassAttendance />} />
    <Route path="routine/manage-exam" element={<ManageExam />} />
    <Route path="routine/exam-report" element={<ExamReport />} />
    <Route path="routine/setting" element={<RoutineSetting />} />
  </React.Fragment>
);
